import React from 'react'
import { SVGProps } from 'react'

const Python = (props: SVGProps<SVGSVGElement>): React.ReactNode => (
  <svg
    {...props}
    className={`SRC-python-icon ${props.className ?? ''}`}
    width="56"
    height="55"
    viewBox="0 0 56 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M28.0169 0C14.1637 9.88087e-07 15.0288 6.00758 15.0288 6.00758L15.0442 12.2314H28.264V14.1001H9.79337C9.79337 14.1001 0.928711 13.0947 0.928711 27.0727C0.92871 41.0507 8.66598 40.555 8.66598 40.555H13.2836V34.0687C13.2836 34.0687 13.0347 26.3314 20.8973 26.3314H34.009C34.009 26.3314 41.3756 26.4505 41.3756 19.2119V7.24307C41.3756 7.24307 42.4941 0 28.0169 0ZM20.7275 4.18523C22.0427 4.18523 23.1058 5.24828 23.1058 6.56355C23.1058 7.87882 22.0427 8.94187 20.7275 8.94187C19.4122 8.94187 18.3491 7.87882 18.3491 6.56355C18.3491 5.24828 19.4122 4.18523 20.7275 4.18523Z" />
    <path d="M28.41 54.2857C42.2632 54.2857 41.3981 48.2781 41.3981 48.2781L41.3827 42.0543H28.1629V40.1857H46.6335C46.6335 40.1857 55.4982 41.191 55.4982 27.213C55.4982 13.235 47.7609 13.7307 47.7609 13.7307H43.1433V20.217C43.1433 20.217 43.3922 27.9543 35.5296 27.9543H22.4179C22.4179 27.9543 15.0513 27.8352 15.0513 35.0738V47.0426C15.0513 47.0426 13.9328 54.2857 28.41 54.2857ZM35.6994 50.1005C34.3842 50.1005 33.3211 49.0374 33.3211 47.7222C33.3211 46.4069 34.3842 45.3438 35.6994 45.3438C37.0147 45.3438 38.0778 46.4069 38.0778 47.7222C38.0778 49.0374 37.0147 50.1005 35.6994 50.1005Z" />
  </svg>
)

export default Python
